import OrderedList from '@tiptap/extension-ordered-list';

/**
 * Extends the default OrderedList extension to support a `type` attribute
 * (`a`, `i`, `A`, `I`) that persists via the HTML `type` attribute on the `<ol>`.
 */
const CustomOrderedList = OrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('type') || null,
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.type) return {};
          return { type: attributes.type };
        },
      },
    };
  },
});

export default CustomOrderedList;
